import { graphql } from '@/lib/query'
import ExternalVideoFragment from '../external-video'
import ImageFragment from '../image'
import VideoPlayerFragment from '../video-player'

const MediaBlockFragment = graphql(
  /* GraphQL */ `
    fragment MediaBlockFragment on MediaBlockRecord @_unmask {
      mediaType
      image {
        ...ImageFragment
      }
      video {
        ...VideoPlayerFragment
      }
      videoExternal {
        ...ExternalVideoFragment
      }
    }
  `,
  [ImageFragment, VideoPlayerFragment, ExternalVideoFragment]
)

export default MediaBlockFragment
